import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ChargingStationDetailsActions } from './ChargingStationDetailsActions';
import { ChargingStationDetailsActionsV201 } from './protocol-v201/ChargingStationDetailsActionsV201';
import { ChargingStationDetailsActionsV21 } from './protocol-v21/ChargingStationDetailsActionsV21';
import { useChargingStationDetails } from './useChargingStationDetails';
import {
  ChargingStationConnectionStatusDot,
  ChargingStationDetailsHeaderSkeleton,
  ChargingStationShadowStatusChip,
} from '@energy-stacks/shared';

export const ChargingStationDetailsHeader = () => {
  const { t } = useTranslation('chargingStations');

  const { chargingStationDetails } = useChargingStationDetails({
    listenToUpdates: true,
  });

  if (!chargingStationDetails) {
    return <ChargingStationDetailsHeaderSkeleton />;
  }

  return (
    <Box mb={3}>
      <Box
        display="flex"
        gap={12}
        overflow={'hidden'}
        justifyContent={'space-between'}
      >
        <Stack gap={4} direction="row" alignItems="center" overflow={'hidden'}>
          <ChargingStationConnectionStatusDot
            status={
              chargingStationDetails.online === 'online' ? 'online' : 'offline'
            }
            type="chargingstation"
          />
          <Typography
            data-testid="chargingStationDetailsHeaderTitle"
            variant="h3"
            sx={{
              textTransform: 'uppercase',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {chargingStationDetails.name ?? ''}
          </Typography>
          <ChargingStationShadowStatusChip
            shadowStatus={chargingStationDetails.csStatus}
          />
        </Stack>

        {chargingStationDetails.ocppProtocol === 'V_16' ? (
          <ChargingStationDetailsActions
            chargingStationDetails={chargingStationDetails}
          />
        ) : null}
        {chargingStationDetails.ocppProtocol === 'V_201' ? (
          <ChargingStationDetailsActionsV201
            chargingStationDetails={chargingStationDetails}
          />
        ) : null}
        {chargingStationDetails.ocppProtocol === 'V_21' ? (
          <ChargingStationDetailsActionsV21
            chargingStationDetails={chargingStationDetails}
          />
        ) : null}
      </Box>
      <Stack direction="row" mt={1} gap={4} alignItems="center">
        <ChargingStationConnectionStatusDot
          status={chargingStationDetails.csmsOnline}
          type="csms"
        />
        <Typography
          data-testid="chargingStationDetailsCentralSystemName"
          color="grey.600"
          fontSize={14}
          overflow={'hidden'}
          textOverflow={'ellipsis'}
        >{`${t('centralSystem')} ${
          chargingStationDetails.csmsDisplayName
        }`}</Typography>
      </Stack>
    </Box>
  );
};
